import { restaurantTz } from '@/lib/hours';
import { utcOffsetForTz } from '@/features/reservation/dateUtils';

/** Compose an ISO 8601 datetime (with explicit offset) for a given date in restaurant TZ at HH:MM.
 *  slot: "HH:MM" (00:00–23:59).
 *  now: snapshot of current Date (used as fallback when targetDate is omitted).
 *  country: restaurant country code (e.g. "FR"). Falls back to FR if unknown.
 *  targetDate: optional explicit date for the slot (e.g. tomorrow). Defaults to now.
 *  timezone: DF-0330 — the restaurant's own IANA timezone (e.g. "America/Cayenne"
 *   for a DOM restaurant whose `country` still reads "FR"). Preferred over
 *   `country` when present and valid; see `restaurantTz`.
 */
export function composeScheduledIso(
  slot: string,
  now: Date,
  country?: string,
  targetDate?: Date,
  timezone?: string | null,
): string {
  const tz = restaurantTz({ timezone, country });
  const dateRef = targetDate ?? now;
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric', month: '2-digit', day: '2-digit',
  });
  const ymd = fmt.format(dateRef);
  const offset = utcOffsetForTz(dateRef, tz);
  return `${ymd}T${slot}:00${offset}`;
}
